/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Input, OnChanges, SimpleChanges} from '@angular/core';

/**
 * Hosts edit/analysis/information panels for a single admin resource route.
 * The route's isNew parameter never flips after save; modelComms does.
 */
export class AdminResourceItemPageBase implements OnChanges {
  @Input() model: any;

  private _modelCommsDirect: any;

  @Input()
  set modelComms(value: any) {
    this._modelCommsDirect = value;
  }

  get modelComms(): any {
    return this._modelCommsDirect;
  }

  private _isNewDirect: boolean;

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  effectiveIsNew = false;

  private subscribedModelComms: any;

  constructor(protected readonly cdr?: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.modelComms) {
      this.wireEffectiveIsNewFromModelComms();
    }
  }

  private wireEffectiveIsNewFromModelComms(): void {
    if (!this.modelComms || this.subscribedModelComms === this.modelComms) {
      return;
    }
    this.subscribedModelComms = this.modelComms;
    this.modelComms.addSubscriber((data: any, type: any, isNewFromComms: boolean) => {
      if (type) {
        return;
      }
      if (isNewFromComms === true || isNewFromComms === false) {
        this.effectiveIsNew = isNewFromComms;
      } else if (data?.name) {
        this.effectiveIsNew = false;
      }
      this.cdr?.markForCheck();
    });
  }
}
